import { useReducer } from "react";
function eq(type) {
    return this.type === type;
}
var defaultState = {
    type: "NOT_ASKED",
    loading: false,
    errors: null,
    data: null,
    eq: eq,
};
function reducer(state, action) {
    switch (action.type) {
        case "NOT_ASKED":
            return {
                type: "NOT_ASKED",
                loading: false,
                errors: null,
                data: null,
                eq: eq,
            };
        case "LOADING":
            return {
                type: "LOADING",
                loading: true,
                errors: null,
                data: null,
                eq: eq,
            };
        case "FAILURE":
            return {
                type: "FAILURE",
                loading: false,
                errors: action.payload,
                data: null,
                eq: eq,
            };
        case "SUCCESS":
            return {
                type: "SUCCESS",
                loading: false,
                errors: null,
                data: action.payload,
                eq: eq,
            };
        default:
            return state;
    }
}
export default function useRemoteDataState(initialState) {
    var _a = useReducer(reducer, initialState || defaultState), remoteData = _a[0], dispatch = _a[1];
    return [remoteData, dispatch];
}
//# sourceMappingURL=useRemoteData.js.map